import AgendaService from './AgendaService';

export default class ResumoService extends AgendaService {
  constructor(resource) {
    super();
    this._resource = resource;
  }

  getResumo(professorId, codPessoaAluno) {
    return this.returnRes({professorId, codPessoaAluno}, ({professorId, codPessoaAluno}) => {
      return this._resource
        .get(`resumos/by/${professorId}/${codPessoaAluno}`);
    });
  }

  setResumo(resumo) {
    return this.returnRes(resumo, (resumo) => {
      return this._resource
        .post(`resumos/`, resumo);
    })
  }

  updateResumo(resumo) {
    return this.returnRes(resumo, (resumo) => {
      return this._resource
        .put(`resumos/${resumo.app_resumo_diarios.resumoId}`, resumo);
    })
  }

  deleteResumo(id) {
    return this.returnRes({id}, ({id}) => {
      return this._resource
        .delete(`resumos/${id}`);
    });
  }

  getAtividades() {
    return this.returnRes({}, () => {
      return this._resource
        .get(`resumos/atividade`);
    });
  }
}



// WEBPACK FOOTER //
// ./src/domain/colegio/ResumoService.js